export default __webpack_public_path__ + "static/media/srednoy_puzankov.a5d5d264.jpg";